<template>
  <div class="ml-5 mr-5">
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-data-iterator
      :items="items"
      item-key="identity"
      :items-per-page="100"
      hide-default-footer
    >
      <template v-slot:header>
        <v-toolbar color="#eee" flat outlined class="mt-4 mb-4" dense>
          <v-icon class="mr-3">mdi-home</v-icon>
          <v-toolbar-title style="font-weight:600;font-size:16px"
            >Welcome, {{ userProfile.name }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
      </template>
      <template v-slot:default="props">
        <v-row>
          <v-col
            v-for="item in props.items"
            :key="item.Identity"
            cols="12"
            sm="6"
            md="4"
            lg="3"
            v-if="canShow(item)"
          >
            <v-card
              class='homecard'
              @click="goTo(item.identity)"
              style="width: 100%; min-height: 140px"
            >
              <div
                style="width: 100%; height: 8px;" class="primary"
              ></div>
              <div class="mt-2 pt-3 pb-3">
                <v-icon class="ma-4" style="font-size: 120px" >{{
                  item.icon
                }}</v-icon>

                <p style="font-size: 18px; font-weight: 500">
                  {{ item.name }}
                </p>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </template>
    </v-data-iterator>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Home",
  computed: {
    ...mapGetters(["userProfile"]),
  },
  data: () => {
    return {
      isLoading: false,
      items: [
        {
          identity: "my-cal",
          name: "My Calendars",
          icon: "mdi-calendar-month-outline",
          isAdmin: false,
        },
        
        {
          identity: "manage-cal",
          name: "Manage Calendars",
          icon: "mdi-calendar-edit",
          isAdmin: true,
        },
       // {
       //   identity: "cal-publisher",
       //   name: "Calendar Publisher",
       //   icon: "mdi-export-variant",
       //   isAdmin: true,
       // },
        {
          identity: "manage-group",
          name: "Manage Groups",
          icon: "mdi-account-group-outline",
          isAdmin: true,
        },
        //{
        //  identity: "manage-user",
        //  name: "Manage Users",
        //  icon: "mdi-account-tie-outline",
        //  isAdmin: true,
        //},
        {
          identity: "help",
          name: "Guide",
          icon: "mdi-information-outline",
          isAdmin: false,
        },
      ],
    };
  },
  methods: {
    goTo(url) {
      let _url = "/" + url;
      if (_url !== this.$route.path) this.$router.push(_url);
    },
    canShow(item) {
      if (item.isAdmin) {
        return this.userProfile.isAdmin || this.userProfile.isCalendarAdmin;
      }
      return true;
    },
  },
  async mounted() {
    if (!this.userProfile) this.isLoading = true;
    await this.$store.dispatch("getUserProfile");
    if (!this.userProfile) 
      window.location = "https://www.nottingham.edu.cn"
    this.isLoading = false;
  },
};
</script>

<style>
.homecard:hover {
  background-color:#e8e9f0!important;
}
</style>